import { render } from "./AppTd.vue?vue&type=template&id=280a1aac&scoped=true"
import script from "./AppTd.vue?vue&type=script&lang=js"
export * from "./AppTd.vue?vue&type=script&lang=js"

import "./AppTd.vue?vue&type=style&index=0&id=280a1aac&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280a1aac"]])

export default __exports__